var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"back-to-top",class:_vm.buttonStyle,style:({'opacity': _vm.opacity}),on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fas fa-arrow-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }